const SMALL = { name: 'SMALL', maxWidth: 640 };
const MEDIUM = { name: 'MEDIUM', maxWidth: 1024 };
const LARGE = { name: 'LARGE' };

export default {
  SMALL,
  MEDIUM,
  LARGE,
};
